import { ObservableMap } from 'owa-mobx4-adapter';
import { createStore } from 'satcheljs';
var attachmentStore = {
    attachments: new ObservableMap({}),
};
export var getStore = createStore('attachment', attachmentStore);
export default getStore;
//# sourceMappingURL=store.js.map